<template>
    <div class="invoicesInfo">
        <van-nav-bar title="查看开票" left-arrow @click-left="onClickLeft" />
        <div class="invoicesInfo-content">
            <div class="info-list">
                <div class="info-item kaipiao">
                    <span>开票状态</span>
                    <span :class="formInfo.invoiceStatus == 2 ? 'green' : 'red'">
                        {{ formInfo.invoiceStatus == 1 ? '审核中' : '已开票' }}
                    </span>
                </div>
                <div class="info-item">
                    <span>发票类型</span>
                    <span>{{ formInfo.invoiceType == 1 ? '普通发票' : '增值税专用发票' }}</span>
                </div>
                <div class="info-item">
                    <span>抬头类型</span>
                    <span>{{ formInfo.invoiceTitleType == 1 ? '单位' : '个人' }}</span>
                </div>
                <div class="info-item">
                    <span>开票金额</span>
                    <span class="money-num">￥{{ formInfo.invoiceAmount }}</span>
                </div>
                <div class="info-item">
                    <span>发票内容</span>
                    <span>{{ formInfo.invoiceContent }}</span>
                </div>
                <!-- 单位 -->
                <div v-if="formInfo.invoiceTitleType == 1">
                    <div class="info-item">
                        <span>单位名称</span>
                        <span>{{ formInfo.invoiceTitle }}</span>
                    </div>
                    <div class="info-item">
                        <span>单位税号</span>
                        <span>{{ formInfo.taxNumber }}</span>
                    </div>
                    <div class="info-item">
                        <span>邮箱地址</span>
                        <span>{{ formInfo.recipientEmail }}</span>
                    </div>
                    <div class="info-item">
                        <span>开户银行</span>
                        <span :class="formInfo.bankName ? '' : 'grey'">{{ formInfo.bankName || '未填写' }}</span>
                    </div>
                    <div class="info-item">
                        <span>银行账号</span>
                        <span :class="formInfo.bankAccount ? '' : 'grey'">{{ formInfo.bankAccount || '未填写' }}</span>
                    </div>
                    <div class="info-item">
                        <span>注册电话</span>
                        <span :class="formInfo.registPhone ? '' : 'grey'">{{ formInfo.registPhone || '未填写' }}</span>
                    </div>
                    <div class="info-item">
                        <span>注册地址</span>
                        <span :class="formInfo.registAdress ? '' : 'grey'">
                            {{ formInfo.registAdress || '未填写' }}
                        </span>
                    </div>
                </div>
                <div v-if="formInfo.invoiceTitleType == 2">
                    <div class="info-item">
                        <span>姓名</span>
                        <span>{{ formInfo.invoiceTitle }}</span>
                    </div>
                    <div class="info-item">
                        <span>身份证号</span>
                        <span>{{ formInfo.idCard }}</span>
                    </div>
                    <div class="info-item">
                        <span>电子邮箱</span>
                        <span>{{ formInfo.recipientEmail }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'invoicesinfo',
    data() {
        return {
            formInfo: {
                invoiceStatus: 1
            },
            id: ''
        }
    },
    created() {
        const { id, invoiceContent } = this.$route.query
        this.id = id
        this.formInfo.invoiceContent = invoiceContent
        this.getData()
    },
    methods: {
        onClickLeft() {
            this.$router.go(-1)
        },
        getData() {
            this.$api.invoice.getDataDetails(this.id).then(res => {
                console.log(res)
                if (res.data) {
                    this.formInfo = { ...res.data }
                }
            })
        }
    }
}
</script>

<style scoped lang="stylus">
@import '../asset/css/invoices.styl'
</style>

<style lang="less" scoped>
.grey {
    color: #999 !important;
}
</style>
